import React, { useContext } from 'react';
import { Link } from 'react-router-dom'
import CustomizerContext from '../../_helper/Customizer'
import { PrimeCollegePrepMark } from '../../Constant'

const SidebarIcon = () => {
	const { layoutURL } = useContext(CustomizerContext)
	return (
		<div className="logo-icon-wrapper">
			<Link to={`${process.env.PUBLIC_URL}/dashboard/default/${layoutURL}`}>
				<img className="img-fluid" src={PrimeCollegePrepMark} alt="Prime College Prep" />
			</Link>
		</div>
	)
}

export default SidebarIcon